type PayloadError = {
  message?: string;
  params?: ReadonlyArray<ErrorParams | undefined>;
};

/**
 * casino_core types payload `errors` (and their `params`) with possibly
 * missing list items (`Array<T | undefined>`), while the form helpers
 * (`setErrors`, `deserializeErrors`, `setPhoneNumberHint`) take a plain
 * `GenericErrorType[]`. Drops the missing items.
 */
const toGenericErrors = (
  errors: ReadonlyArray<PayloadError | undefined>,
): GenericErrorType[] =>
  errors
    .filter((error): error is PayloadError => error != null)
    .map(({ message, params }) => ({
      message,
      params: params?.filter((param): param is ErrorParams => param != null),
    }));

export default toGenericErrors;
